export const translations = {
  noResult: {
    pt: 'Sem Resultados...',
    en: 'No Results...',
    de: 'Keine Ergebnisse...',
    es: 'Sin Resultados...',
  },
};
